import React from 'react';

const AppointmentIcon = ({
  size = 24,
  color = 'currentColor',
  className = '',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      {...props}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M15.25 5.316c0 .41.34.75.75.75s.75-.34.75-.75v-.534c.681.138 1.18.364 1.55.734c.532.533.766 1.328.87 2.55H2.83c.104-1.222.338-2.017.87-2.55c.37-.37.869-.596 1.55-.734v.534c0 .41.34.75.75.75s.75-.34.75-.75v-.703c.876-.047 1.944-.047 3.25-.047h2c1.306 0 2.374 0 3.25.047zM2.763 9.566c-.013.659-.013 1.404-.013 2.25v2.501c0 3.56 0 5.35.95 6.3s2.74.95 6.3.95h1.5c.41 0 .75.34.75.75s-.34.75-.75.75H10c-3.98 0-5.97 0-7.36-1.39s-1.39-3.38-1.39-7.36v-2.5c0-3.98 0-5.97 1.39-7.36c.675-.676 1.492-1.023 2.61-1.202v-.939c0-.41.34-.75.75-.75s.75.34.75.75v.796c.91-.046 1.979-.046 3.25-.046h2c1.271 0 2.34 0 3.25.046v-.796c0-.41.34-.75.75-.75s.75.34.75.75v.94c1.118.178 1.935.525 2.61 1.2c1.39 1.39 1.39 3.38 1.39 7.36v1.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.5c0-.846 0-1.591-.013-2.25zM16 23.066h-.09a.76.76 0 0 1-.62-.51c-.505-1.544-1.462-1.994-1.554-2.037l-.006-.002a.757.757 0 0 1-.42-.97c.15-.38.58-.57.96-.43c.058.023 1.063.424 1.86 1.69c1.15-1.59 3.44-4.42 5.62-5.2c.39-.14.82.07.96.46s-.07.82-.46.96c-2.11.75-4.77 4.37-5.62 5.7a.75.75 0 0 1-.63.35z"
      />
    </svg>
  );
};

export default AppointmentIcon;
